document.addEventListener('DOMContentLoaded', function () {

    const nav = document.getElementById('am_navbar_exp');
    const lowerMenu = document.getElementById('am_menu_controller_lowerlevel');
    const upperNav = document.getElementById('am_navbar_static_responsive_upperlevel');
    const associationDropdown = document.getElementById('association_dropdown');
    const originatorText = document.getElementById('toggle-my-originator-text');
    const loInfo = document.getElementById('inner_lo_association_details');
    const mobileNav = document.getElementById('exclusive_nav-mobile');
    const navMenuController = document.getElementById('am_navmenu_controller');
    let isMenuOpen = false, isHovering = false;
    const lowerMenuDisplay = lowerMenu?.style.display || '';
    const loInfoDisplay = loInfo?.style.display || '';
    const originalInlineStyles = [];
    const setDisplay = (el, show, def) => { if (el) el.style.display = show ? def : 'none'; };
    const setNavOpacity = () => {
        if (!nav) return;
        nav.style.opacity = isHovering || window.scrollY === 0 ? '1' : (1 - Math.min(window.scrollY, 400) / 400).toString();
    };
    const setHamburgerIcon = open => {
        if (!mobileNav) return;
        const svg = mobileNav.querySelector('svg');
        if (!svg) return;
        svg.innerHTML = open
            ? `<line x1="8" y1="8" x2="24" y2="24" stroke="white" stroke-width="3" stroke-linecap="round"/>
               <line x1="24" y1="8" x2="8" y2="24" stroke="white" stroke-width="3" stroke-linecap="round"/>`
            : `<rect y="7" width="32" height="3" rx="1.5"></rect>
               <rect y="14.5" width="32" height="3" rx="1.5"></rect>
               <rect y="22" width="32" height="3" rx="1.5"></rect>`;
    };
    const adjustNavMargin = () => {
        if (window.innerWidth >= 1249 && nav) {
            nav.style.zIndex = '99998';
            const navHeight = nav.offsetHeight;
            document.body.style.marginTop = (navHeight + 20) + 'px';
            document.querySelectorAll('.inner_sublevel_navigation_experience').forEach(el => {
                el.style.marginTop = (navHeight + 5) + 'px';
            });
        } else {
            document.body.style.marginTop = (upperNav?.offsetHeight || 0) + 'px';
        }
    };
    const wpAdminBar = document.getElementById('wpadminbar');
    if (window.innerWidth >= 1249 && wpAdminBar) {
        nav.style.top = (wpAdminBar.offsetHeight + 9) + 'px';
        adjustNavMargin();
    }
    function setupMobile() {
        setDisplay(lowerMenu, false, lowerMenuDisplay || 'flex');
        setDisplay(loInfo, true, loInfoDisplay || 'grid');
        setHamburgerIcon(isMenuOpen);
        if (mobileNav) {
            mobileNav.onclick = () => {
                isMenuOpen = !isMenuOpen;
                setHamburgerIcon(isMenuOpen);
                setDisplay(lowerMenu, isMenuOpen, lowerMenuDisplay || 'flex');
                nav?.classList.toggle('opentray', isMenuOpen);
                document.body.style.overflow = isMenuOpen ? 'hidden' : '';
            };
        }
    }
    function teardownMobile() {
        if (mobileNav) mobileNav.onclick = null;
        setHamburgerIcon(false);
        setDisplay(lowerMenu, true, lowerMenuDisplay || 'flex');
        setDisplay(loInfo, false, loInfoDisplay || 'grid');
        document.body.style.overflow = '';
        nav?.classList.remove('opentray');
        isMenuOpen = false;
    }
    function setupDesktop() {
        setDisplay(lowerMenu, true, lowerMenuDisplay || 'flex');
        setDisplay(loInfo, false, loInfoDisplay || 'grid');
        setHamburgerIcon(false);
        if (mobileNav) mobileNav.onclick = null;
        document.querySelectorAll('.standard_navigational_items.navigation-items').forEach(menu => {
            Array.from(menu.children).forEach(item => {
                item.onmouseenter = () => {
                    menu.querySelectorAll('.has-dropdown').forEach(sib => sib.classList.remove('active-stick'));
                    document.querySelectorAll('.navigation_sublevel_experience_desktop').forEach(el => el.style.display = 'none');
                    if (item.classList.contains('has-dropdown')) {
                        item.classList.add('active-stick');
                        document.querySelectorAll('.navigation_sublevel_experience_desktop').forEach(el => {
                            el.style.display = window.innerWidth > 1249 ? 'block' : 'none';
                        });
                    }
                };
            });
            const upperLevel = document.querySelector('.navigation_primary_experience_static_upperlevel');
            if (upperLevel) {
                upperLevel.onmouseenter = () => {
                    document.querySelectorAll('.active-stick').forEach(el => el.classList.remove('active-stick'));
                    document.querySelectorAll('.navigation_sublevel_experience_desktop').forEach(el => el.style.display = 'none');
                    document.querySelectorAll('.desktop-grandchild-menu-container ul[data-parent]').forEach(ul => ul.style.display = 'none');
                };
            }
        });
        if (nav) {
            nav.addEventListener('mouseleave', () => {
                document.querySelectorAll('.active-stick').forEach(el => el.classList.remove('active-stick'));
                document.querySelectorAll('.navigation_sublevel_experience_desktop').forEach(el => el.style.display = 'none');
                document.querySelectorAll('.desktop-grandchild-menu-container ul[data-parent]').forEach(ul => ul.style.display = 'none');
            });
        }
        document.querySelectorAll('.desktop-child-menu-container').forEach(container => {
            const items = container.querySelectorAll('.child-menu-item.has-dropdown');
            items.forEach(item => {
                item.onmouseenter = () => {
                    items.forEach(sib => sib.classList.remove('active-stick'));
                    item.classList.add('active-stick');
                    const val = item.getAttribute('data-child');
                    document.querySelectorAll('.desktop-grandchild-menu-container ul[data-parent]').forEach(ul => {
                        ul.style.display = (ul.getAttribute('data-parent') === val && item.classList.contains('active-stick')) ? 'grid' : 'none';
                    });
                };
            });
            container.querySelectorAll('.child-menu-item:not(.has-dropdown)').forEach(item => {
                item.onmouseenter = () => {
                    items.forEach(i => i.classList.remove('active-stick'));
                    document.querySelectorAll('.desktop-grandchild-menu-container ul[data-parent]').forEach(ul => ul.style.display = 'none');
                };
            });
        });
        document.onclick = e => {
            if (!nav?.contains(e.target)) {
                document.querySelectorAll('.active-stick').forEach(el => el.classList.remove('active-stick'));
                document.querySelectorAll('.navigation_sublevel_experience_desktop').forEach(el => el.style.display = 'none');
                document.querySelectorAll('.desktop-grandchild-menu-container ul[data-parent]').forEach(ul => ul.style.display = 'none');
            }
        };
    }
    function teardownDesktop() {
        document.querySelectorAll('.standard_navigational_items.navigation-items').forEach(menu => {
            Array.from(menu.children).forEach(item => item.onmouseenter = null);
        });
        document.querySelectorAll('.desktop-child-menu-container .child-menu-item').forEach(item => item.onmouseenter = null);
        document.onclick = null;
        if (associationDropdown) {
            associationDropdown.onmouseenter = null;
            associationDropdown.onmouseleave = null;
        }
        setDisplay(loInfo, true, loInfoDisplay || 'grid');
    }
    function handleResponsive() {
        if (window.innerWidth < 1249) {
            teardownDesktop();
            setupMobile();
        } else {
            teardownMobile();
            setupDesktop();
        }
        adjustNavMargin();
        nav && nav.classList.toggle('menu-top', window.scrollY === 0);
        if (window.innerWidth >= 1249) setNavOpacity();
    }
    nav?.addEventListener('mouseenter', () => { isHovering = true; nav.style.opacity = '1'; });
    nav?.addEventListener('mouseleave', () => { isHovering = false; if (window.innerWidth >= 1249) setNavOpacity(); });
    document.querySelectorAll('[style]').forEach(el => {
        originalInlineStyles.push({ element: el, style: el.getAttribute('style') });
    });
    window.addEventListener('resize', () => {
        document.querySelectorAll('.item.active-stick').forEach(el => el.classList.remove('active-stick'));
        originalInlineStyles.forEach(({ element, style }) => element?.setAttribute('style', style || ''));
        handleResponsive();
    });
    window.addEventListener('scroll', () => {
        nav && nav.classList.toggle('menu-top', window.scrollY === 0);
        if (window.innerWidth >= 1249) setNavOpacity();
    });
    if (nav) {
        nav.addEventListener('click', function (e) {
            if (
                window.innerWidth >= 1249 &&
                !e.target.closest('li') &&
                nav.contains(e.target) &&
                window.scrollY !== 0
            ) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        });
    }
    handleResponsive();
    if (window.innerWidth >= 1249) window.scrollTo(0, 0);
    (function dbaStringsInterpolation() {
        const dbaNameFull = document.body.getAttribute("data-dbanamefull") || "AnnieMac Home Mortgage";
        document.querySelectorAll("p, h1, h2, h3, h4, h5, h6, li, span").forEach(el => {
            if (el.textContent.includes("{{dba}}")) {
                el.textContent = el.textContent.replace(/{{dba}}/g, dbaNameFull);
            }
        });
    })();
    if (associationDropdown && originatorText && loInfo) {
        const handleAssociationDropdown = () => {
            if (window.innerWidth >= 1249) {
                associationDropdown.onmouseenter = () => {
                    if (originatorText.innerText.trim() === 'My Originator') {
                        loInfo.style.display = 'flex';
                        loInfo.style.zIndex = '999999';
                    }
                };
                associationDropdown.onmouseleave = () => {
                    if (originatorText.innerText.trim() === 'My Originator') setDisplay(loInfo, false, loInfoDisplay || 'grid');
                };
            } else {
                associationDropdown.onmouseenter = null;
                associationDropdown.onmouseleave = null;
                loInfo.style.display = 'grid';
                loInfo.style.zIndex = '';
            }
        };
        handleAssociationDropdown();
        window.addEventListener('resize', handleAssociationDropdown);
    }
});